import {useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {getCustomerCenterDetail} from "../../apis/contents";
import {H3} from "../../components/H3";
import {CustomerCenterDto} from "../../types/types";

export default () => {
    const {id} = useParams<{ id: string }>();
    const numID = parseInt(id);
    const [content, setContent] = useState<CustomerCenterDto>();

    useEffect(() => {
        getCustomerCenterDetail(numID).then(r => setContent(r.data.payload))
    }, [id])

    if (!content) return null
    return (
        <>
                <div className="bgcolorf5f5f5 md:-mx-4 -mx-8 pt-10 pb-10 px-5 pl-14 md:pl-5 md:-mt-10 -mt-0">
                    <H3 className="font-semibold text-16 text-center pb-10">{content.title}</H3>
                    <div className="flex flex-col items-center justify-center space-y-8 max-w-3xl m-auto">
                        <div className="text-12 flex flex-col text-left space-y-6">
                            <p className="flex flex-col whitespace-pre-wrap">
                                {content.content}
                            </p>
                        </div>
                    </div>
                </div>
        </>
    )
}
